export const STORE_LINKS = {
  ios: "https://www.apple.com/fr/search/fastority?src=globalnav",
  android: "https://play.google.com/store/search?q=fastority&c=apps",
};
